import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { Http, RequestOptions, Headers, Response } from '@angular/http';

declare var i18nVS: any;
declare var portletNameLogin: any; // Nombre del portlet en Liferay
declare var areaPrivadaURL: any;
declare var idCiudadLiferay;
declare var responsesMap;
declare var liferayUserNoAdmin;

declare var MarruecosLogin;  // RC, loguearse
declare var MarruecosLogout; // RC, desloguearse
declare var MarruecosSignUp; // RC, crear nueva cuenta
declare var MarruecosSendRecoverPassword; // RC, mandar nueva contraseña

declare var showLoginPopUp;

declare function sendFormFunction(idForm, finalURL);

declare function setLiferayUserWasLoggedCookie(valor);

@Component({
    selector: 'app-login-sign-up',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})

export class AppComponent implements OnInit {
    required_error_class = 'error-input';

    i18nL = i18nVS;

    liferayUserNoAdmin = liferayUserNoAdmin;

    MarruecosLogout = MarruecosLogout;

    userNameInput;
    userPassInput;
    signUpUserNameInput;
    signUpNameInput;
    signUpSurnameInput;
    signUpCINInput;
    signUpBirthdateInput;
    signUpAddressInput;
    signUpCityInput;
    signUpPhoneInput;
    userNameRecoverPasswordInput;

    userNameClass = '';
    passwordClass = '';
    signUpUserNameClass = '';
    signUpNameClass = '';
    signUpSurnameClass = '';
    signUpCINClass = '';
    dateClass = '';
    signUpAddressClass = '';
    signUpCityClass = '';
    signUpPhoneClass = '';
    userNameRecoverPasswordClass = '';

    showLogIn = true;
    showSignUp = false;
    showResponse = false;
    showRecoverPassword = false;

    checkResultado = null;
    modalCerrarSesionClass = 'invisible';

    portletName;
    areaPrivadaURL;

    responseFormSpinner = "";
    errorResponseForm = "invisible";
    successResponseForm = "invisible";
    responseText = "";
    responseMapKey = 0;

    // Controlamos las fechas minimas y maximas de la fecha de nacimiento
    maxDate = new Date();
    minDate = new Date();

    @Output() onWebServiceError: EventEmitter<boolean> = new EventEmitter<boolean>();

    /*----------------------------------------------- Funciones ----------------------------------------------------*/
    public toggleLoginModalWindow() {
        showLoginPopUp = !showLoginPopUp;
    }

    public toggleLoginModalWindowCorrutine() {
        if (showLoginPopUp) {
            this.modalCerrarSesionClass = 'visible';
        } else {
            this.modalCerrarSesionClass = 'invisible';
        }
        setTimeout(() => this.toggleLoginModalWindowCorrutine(), 250);
    }

    public clearClass(input) {
        switch (input) {
            case 1: {
                if (this.userNameInput.value.trim() !== '') {
                    this.userNameClass = '';
                }
                break;
            } case 2: {
                if (this.userPassInput.value.trim() !== '') {
                    this.passwordClass = '';
                }
                break;
            } case 3: {
                if (this.signUpUserNameInput.value.trim() !== '') {
                    this.signUpUserNameClass = '';
                }
                break;
            } case 6: {
                if (this.signUpNameInput.value.trim() !== '') {
                    this.signUpNameClass = '';
                }
                break;
            } case 7: {
                if (this.signUpSurnameInput.value.trim() !== '') {
                    this.signUpSurnameClass = '';
                }
                break;
            } case 8: {
                if (this.signUpCINInput.value.trim() !== '') {
                    this.signUpCINClass = '';
                }
                break;
            } case 9: {
                if (this.signUpBirthdateInput.value.trim() !== '') {
                    this.dateClass = '';
                }
                break;
            } case 10: {
                if (this.signUpAddressInput.value.trim() !== '') {
                    this.signUpAddressClass = '';
                }
                break;
            } case 11: {
                if (this.signUpPhoneInput.value.trim() !== '') {
                    this.signUpPhoneClass = '';
                }
                break;
            } case 20: {
                if (this.userNameRecoverPasswordInput.value.trim() !== '') {
                    this.userNameRecoverPasswordInput = '';
                }
                break;
            } default: {
                console.log("Clear input undefined");
                break;
            }
        }
    }

    public validateLoginForm() {
        let formularioValidado = true;

        if (this.userNameInput.value.trim() === '') {
            this.userNameInput.placeholder = this.i18nL.form_campoObligatorio;
            this.userNameClass = this.required_error_class;
            formularioValidado = false;
        }

        if (this.userPassInput.value.trim() === '') {
            this.userPassInput.placeholder = this.i18nL.form_campoObligatorio;
            this.passwordClass = this.required_error_class;
            formularioValidado = false;
        }

        // Si el formulario valida lo mandamos por ajax
        if (formularioValidado) {
            this.showResponseForm();
            this.responseMapKey = sendFormFunction("loginForm", MarruecosLogin);
        }
        // Evitamos que el formulario se envie
        return false;
    }

    public validateSignUpForm() {
        let formularioValidado = true;

        if (this.signUpUserNameInput.value.trim() === '') {
            this.signUpUserNameInput.placeholder = this.i18nL.form_campoObligatorio;
            this.signUpUserNameClass = this.required_error_class;
            formularioValidado = false;
        }

        if (this.signUpNameInput.value.trim() === '') {
            this.signUpNameInput.placeholder = this.i18nL.form_campoObligatorio;
            this.signUpNameClass = this.required_error_class;
            formularioValidado = false;
        }

        if (this.signUpSurnameInput.value.trim() === '') {
            this.signUpSurnameInput.placeholder = this.i18nL.form_campoObligatorio;
            this.signUpSurnameClass = this.required_error_class;
            formularioValidado = false;
        }

        if (this.signUpCINInput.value.trim() === '') {
            this.signUpCINInput.placeholder = this.i18nL.form_campoObligatorio;
            this.signUpCINClass = this.required_error_class;
            formularioValidado = false;
        }

        if (this.signUpBirthdateInput.value.trim() === '') {
            this.signUpBirthdateInput.placeholder = this.i18nL.form_campoObligatorio;
            this.dateClass = this.required_error_class;
            formularioValidado = false;
        }

        if (this.signUpAddressInput.value.trim() === '') {
            this.signUpAddressInput.placeholder = this.i18nL.form_campoObligatorio;
            this.signUpAddressClass = this.required_error_class;
            formularioValidado = false;
        }

        if (this.signUpPhoneInput.value.trim() === '') {
            this.signUpPhoneInput.placeholder = this.i18nL.form_campoObligatorio;
            this.signUpPhoneClass = this.required_error_class;
            formularioValidado = false;
        }

        if (this.signUpCityInput.value.trim() === '') {
            this.signUpCityClass = this.required_error_class;
            formularioValidado = false;
        }

        // Si el formulario valida lo mandamos por ajax
        if (formularioValidado) {
            this.showResponseForm();
            this.responseMapKey = sendFormFunction("signUpForm", MarruecosSignUp);
        }

        // Evitamos que el formulario se envie
        return false;
    }

    public showRecoverPasswordForm() {
        this.resetView();
        this.showRecoverPassword = true;
    }

    public sendRecoverPassword() {
        // Si el formulario valida lo mandamos por ajax
        if (this.userNameRecoverPasswordInput.value.trim() === '') {
            this.userNameRecoverPasswordInput.placeholder = this.i18nL.form_campoObligatorio;
            this.userNameRecoverPasswordClass = this.required_error_class;
            return false;
        }
        this.responseMapKey = sendFormFunction("showRecoverPasswordForm", MarruecosSendRecoverPassword);
        this.showResponseForm();
        return false;
    }

    public logOutForm() {
        this.showResponseForm();
        this.responseMapKey = sendFormFunction("redirectLogOutForm", MarruecosLogout);
        // Quitamos la cookie que indicaba que estabas logueado
        setLiferayUserWasLoggedCookie(false);
    }

    public resetView() {
        this.showLogIn = false;
        this.showSignUp = false;
        this.showRecoverPassword = false;
        this.showResponse = false;
    }

    public showSignUpForm() {
        this.resetView();
        this.showSignUp = true;
    }

    // cuando estamos en el formulario de registro de nuevo usuario nos permite volver al formulario de login
    public showLoginForm() {
        this.resetView();
        this.showLogIn = true;
    }

    public showResponseForm() {
        this.resetView();
        this.showResponse = true;
        this.checkForResponseCorutine();
        this.responseFormSpinner = "";
        this.successResponseForm = "invisible";
        this.errorResponseForm = "invisible";
        this.responseText = "";
    }

    private checkForResponseCorutine() {
        if (typeof responsesMap.get(this.responseMapKey) != 'undefined' && responsesMap.get(this.responseMapKey) != "" && this.showResponse) {
            this.responseFormSpinner = "invisible";
            var actualResponse = JSON.parse(responsesMap.get(this.responseMapKey));
            if (actualResponse.success != null) {
                this.successResponseForm = "";
                this.responseText = actualResponse.success;
            } else {
                this.errorResponseForm = "";
                this.responseText = actualResponse.error;
            }

            // ActionId para refrescar la pagina tras el logout
            if (actualResponse.actionId == 1) {
                location.reload();
            }

            // ActionId para ir al area privada tras un login satisfactorio
            if (actualResponse.actionId == 2) {
                location.href = actualResponse.extraInformation;
            }

            this.responseMapKey = -1;
        } else {
            setTimeout(() => this.checkForResponseCorutine(), 250);
        }
    }

    /**
     * valida objetos JSON
     * @param res recurso a validar
     */
    private validateJSON(res: Response, url: string) {
        try {
            this.checkResultado = res.json();
        } catch (error) {
            console.log(res);
            this.errorEnElJson("Error parseando el json", url);
        }
    }

    public omit_special_char(event) {
        var k = event.charCode;  // k = event.keyCode;  (Both can be used)
        return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 /*|| k == 32*/ || (k >= 48 && k <= 57));
    }

    /**
     * Procesa errores detectados en el formato JSON
     */
    private errorEnElJson(err: string, url: string) {
        console.log('Error en la llamada: ' + err);
        console.log(url);
        this.onWebServiceError.emit(true);
    }

    /*--------------------------------------------- Eventos ------------------------------------------------------*/
    ngOnInit() {
        this.portletName = portletNameLogin;
        this.areaPrivadaURL = areaPrivadaURL;
        this.maxDate.setFullYear(this.maxDate.getFullYear() - 1);
        this.minDate.setFullYear(this.minDate.getFullYear() - 100);
        this.toggleLoginModalWindowCorrutine();
    }

    ngAfterViewChecked() {
        // Inputs del login
        this.userNameInput = (<HTMLInputElement>document.getElementById("userName"));
        this.userPassInput = (<HTMLInputElement>document.getElementById("userPass"));

        // Inputs del signUp
        this.signUpUserNameInput = (<HTMLInputElement>document.getElementById("signUpUserName"));
        this.signUpNameInput = (<HTMLInputElement>document.getElementById("signUpName"));
        this.signUpSurnameInput = (<HTMLInputElement>document.getElementById("signUpSurname"));
        this.signUpCINInput = (<HTMLInputElement>document.getElementById("signUpCIN"));
        this.signUpBirthdateInput = (<HTMLInputElement>document.getElementById("signUpBirthdate"));
        this.signUpAddressInput = (<HTMLInputElement>document.getElementById("signUpAddress"));
        this.signUpCityInput = (<HTMLInputElement>document.getElementById("signUpCity"));
        this.signUpPhoneInput = (<HTMLInputElement>document.getElementById("signUpPhone"));
        this.userNameRecoverPasswordInput = (<HTMLInputElement>document.getElementById("userNameRecoverPassword"));

        // En caso de que nos encontremos en marruecos no se pondra ninguna
        if (this.signUpCityInput != null && this.signUpCityInput.value == "") {
            this.signUpCityInput.value = idCiudadLiferay;
        }
    }

    /*--------------------------------------------- Constructores ------------------------------------------------*/
    constructor(@Inject(Http) private ajaxRequest) { }
}



// WEBPACK FOOTER //
// ./src/app/login.component.ts